import { Helmet } from "react-helmet";

import './Portfolio.scss';
import './Marketplace.css'
import { Link } from 'react-router-dom'
import { AiOutlineArrowRight } from 'react-icons/ai';
import Tabs from './Tabs.jsx'
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../index";
import { collection,getDocs } from 'firebase/firestore'

function Marketplace(props) {
    const {db,store} = useContext(Context)
    const messages = collection(db, 'portfolio')
    const portfolioData = store.getState().market.market
    const [portfolioDataState,setPortfolioDataState] = useState(null)

  


    return (
        <div>
            <Helmet>
                <title>Digital Visibility Concepts | Burbank SEO Company</title>
                <link rel="canonical" href="http://eliteglobesolutions.com/portfolio" />
                <meta name="description" content="Burbank SEO Company" />
            </Helmet>
            <div className="portfolio">
                <div className="container">
                    <div className="portfolio__tab" data-aos="zoom-in" data-aos-offset="300">
                        <Tabs>
                            <div label="All">
                                <div className="portfolioItems">
             {
                                        portfolioData.map(item => (
                                            <Link to={`/marketplace/${item.path}`}
                                                className="singlePortfolio"
                                                key={item.id}
                                            >
                                                <div className="port_img">
                                                    <img src={item.img} alt="" draggable="false" />
                                                </div>
                                                <h3>{item.mainTitle}</h3>

                                                <div className="arrowbtn"><AiOutlineArrowRight className="arrowbtn-icon"/></div>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>
                            <div label="Low Poly">
                                <div className="portfolioItems">
                                    {
                                        portfolioData.filter(item => item.type === 'lp').map(item => (
                                            <Link to={`/marketplace/${item.path}`}
                                                className="singlePortfolio"
                                                key={item.id}
                                            >
                                                <div className="port_img">
                                                    <img src={item.img} alt="" draggable="false" />
                                                </div>
                                                <h3>{item.mainTitle}</h3>
                                                <div className="arrowbtn"><AiOutlineArrowRight /></div>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>
                            <div label="Rigged">
                                <div className="portfolioItems">
                                    {
                                        portfolioData.filter(item => item.type === 'rig').map(item => (
                                            <Link to={`/marketplace/${item.path}`}
                                                className="singlePortfolio"
                                                key={item.id}
                                                
                                            >
                                                <div className="port_img">
                                                    <img src={item.img} alt="" draggable="false" />
                                                </div>
                                                <h3>{item.mainTitle}</h3>
                                                <div className="arrowbtn"><AiOutlineArrowRight /></div>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>

                            <div label="Animated">
                                <div className="portfolioItems">
                                    {
                                        portfolioData.filter(item => item.type === 'anim').map(item => (
                                            <Link to={`/marketplace/${item.path}`}
                                                className="singlePortfolio"
                                                key={item.id}
                                            >
                                                <div className="port_img">
                                                    <img src={item.img} alt="" draggable="false" />
                                                </div>
                                                <h3>{item.mainTitle}</h3>
                                                <div className="arrowbtn"><AiOutlineArrowRight /></div>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>
                            <div label="Textured">
                                <div className="portfolioItems">
                                    {
                                        portfolioData.filter(item => item.type === 'texture').map(item => (
                                            <Link to={`/marketplace/${item.path}`}
                                                className="singlePortfolio"
                                                key={item.id}
                                            >
                                                <div className="port_img">
                                                    <img src={item.img} alt="" draggable="false" />
                                                </div>
                                                <h3>{item.mainTitle}</h3>
                                                <div className="arrowbtn"><AiOutlineArrowRight /></div>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Marketplace;
